module.exports = __webpack_public_path__ + "static/img/ecaray_about_introduction_honor02.9a834180.png";